import * as React from "react";
import Tooltip from "@src/components/ui/Tooltip";

interface Props {
    text: string,
    subtext?: string,
    right_text?: string,
    icons?: any,
    onClick?: any,
    onSelected?: any,
    onConfirm?: any,
    id?: any,
    selected?: boolean,
    actions?: any
}

interface State {
    
}

export default class ListItem extends React.Component<Props, State> {
    constructor(props) {
        super(props);
    }

    onClick() {
        if(this.props.onSelected)
            this.props.onSelected(this.props.id);
    }

    onChoose() {
        if(this.props.onConfirm)
            this.props.onConfirm();
    }

    mapIcons(icon, index) {
        return <i className={icon} key={index} onClick={this.props.actions[index]}></i>;
    }

    render() {
        let col_name = "col-xs-9";
        let col_right = "";
        let col_icons = "";

        if(this.props.icons && this.props.right_text) {
            col_name = "col-xs-9 col-sm-8";
            col_right = "col-xs-10 col-sm-2";
            col_icons = "col-xs-2 col-sm-2";
        } else if(this.props.icons) {
            col_name = "col-xs-10 col-sm-9";
            col_right = "";
            col_icons = "col-xs-2 col-sm-3";
        } else if(this.props.right_text) {
            col_name = "col-xs-9 col-sm-8";
            col_right = "col-xs-12 col-sm-4";
            col_icons = "";
        }

        let style_list = "listItem";
        if(this.props.selected)
            style_list = "listItem selected";

        if(this.props.subtext !== undefined && this.props.subtext !== '') {
            style_list = style_list + " subtext";
            col_name = col_name + " subtext";
        }


        return (
            <div className={style_list} onClick={this.onClick.bind(this)} key={this.props.id} >
                <div className={col_name + " name"} >
                    { this.props.text }
                    <div className="_subtext">
                        {this.props.subtext}
                    </div>
                </div>
                {
                    this.props.icons && (<div className={col_icons + " right-icons"}>
                        {this.props.icons.map(this.mapIcons.bind(this))}
                    </div>)
                }
                {
                    this.props.right_text && (<div className={col_right + " right-column"}>
                        <span>{ this.props.right_text }</span>
                    </div>)
                }
                {this.props.selected && (
                    <div className="col-xs-3 choose">
                        <button className="btn action xs" onClick={this.onChoose.bind(this)}><span>Scegli</span></button>
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/ListItem.tsx